import { createContext, useState } from 'react';

export const ProductContext = createContext([]);
const ProductProvider = ({ children }: any) => {
  const [product, setProduct] = useState([] as any);
  const [productItem, setProductItem] = useState([] as any);
  const [addressDetail, setAddressDetail] = useState([] as any);
  const [productImport, setProductImport] = useState([] as any);
  const [productImportItem, setProductImportItem] = useState([] as any);
  const [productImportQuotation, setProductImportQuotation] = useState(
    [] as any
  );

  const [proDeWare, setProDeWare] = useState([] as any);
  const [proWareItem, setWareItem] = useState([] as any);
  const [listImgCommentWare, setListImgCommentWare] = useState([] as any);
  const [listImgCreate, setListImgCreate] = useState([] as any);
  const [arrIdImg, setArrIdImg] = useState([] as any);
  const [listCreateCmt, setListCreateCmt] = useState([] as any);
  const [listNewCommentSell, setListNewCommentSell] = useState([] as any);

  const [listInventory, setListInventory] = useState([] as any);

  const [loading, setLoading] = useState(false);
  const [idInventory, setIdInventory] = useState();
  const [listDetailInventory, setListDetailInventory] = useState([] as any);

  const [listImg, setListImg] = useState([] as any);

  const [infoAccount, setInfoAccount] = useState([] as any);
  const [tab, setTab] = useState('');

  return (
    <ProductContext.Provider
      value={
        [
          listDetailInventory,
          setListDetailInventory,
          idInventory,
          setIdInventory,
          loading,
          setLoading,
          listInventory,
          setListInventory,
          listNewCommentSell,
          setListNewCommentSell,
          listImgCreate,
          setListImgCreate,
          listCreateCmt,
          setListCreateCmt,
          listImgCommentWare,
          setListImgCommentWare,
          arrIdImg,
          setArrIdImg,
          product,
          setProduct,
          productItem,
          setProductItem,
          proDeWare,
          setProDeWare,
          proWareItem,
          productImport,
          setProductImport,
          productImportItem,
          setProductImportItem,
          productImportQuotation,
          setProductImportQuotation,
          addressDetail,
          setAddressDetail,

          setWareItem,

          listImg,
          setListImg,
          infoAccount,
          setInfoAccount,
          tab,
          setTab
        ] as any
      }
    >
      {children}
    </ProductContext.Provider>
  );
};

export default ProductProvider;
